import React from 'react'
import {
  ErrorContainer,
  ErrorTitle,
  ErrorDescription,
} from './components/index.styles'
import { Box, IconWarning_2, ShapeIcons } from '@creditas-ui/react'

const Error = () => {
  return (
    <ErrorContainer>
      <Box
        maxWidth={370}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Box mb={24}>
          <ShapeIcons size="x_small" Icon={IconWarning_2} />
        </Box>
        <ErrorTitle>Oops! Algo deu errado</ErrorTitle>
        <ErrorDescription variant="paragraph">
          Por favor, recarregue a página ou tente novamente mais tarde.
        </ErrorDescription>
      </Box>
    </ErrorContainer>
  )
}

export { Error }
